/* src/app/private/configrations/pipeline-configuration/delete-pipeline/delete-pipeline.component.scss */
.delete-dialog {
  padding: 1.5rem;
}
.delete-dialog .delete-header {
  text-align: center;
  margin-bottom: 1.5rem;
  padding-bottom: 1.5rem;
  border-bottom: 1px solid #dee2e6;
}
.delete-dialog .delete-header h3 {
  margin: 0;
  color: #dc3545;
}
.delete-dialog .delete-header p {
  margin: 0;
  font-size: 0.95rem;
}
.delete-dialog .delete-content {
  margin-bottom: 1.5rem;
}
.delete-dialog .delete-content .pipeline-info {
  background: #f8f9fa;
  border-radius: 8px;
  padding: 1rem;
  margin-bottom: 1rem;
}
.delete-dialog .delete-content .pipeline-info .info-item {
  display: flex;
  justify-content: space-between;
  padding: 0.5rem 0;
  border-bottom: 1px solid #dee2e6;
}
.delete-dialog .delete-content .pipeline-info .info-item:last-child {
  border-bottom: none;
}
.delete-dialog .delete-content .pipeline-info .info-item .label {
  font-weight: 600;
  color: #6c757d;
}
.delete-dialog .delete-content .pipeline-info .info-item .value {
  color: #495057;
  font-weight: 500;
}
.delete-dialog .delete-content .pipeline-info .info-item .value.badge-default {
  background: var(--primary-color);
  color: white;
  padding: 0.25rem 0.75rem;
  border-radius: 12px;
  font-size: 0.85rem;
}
.delete-dialog .delete-content .warning-message {
  display: flex;
  align-items: flex-start;
  gap: 0.75rem;
  padding: 1rem;
  background: #fff3cd;
  border: 1px solid #ffc107;
  border-radius: 8px;
}
.delete-dialog .delete-content .warning-message i {
  color: #856404;
  font-size: 1.25rem;
  margin-top: 0.1rem;
}
.delete-dialog .delete-content .warning-message p {
  margin: 0;
  color: #856404;
  font-size: 0.9rem;
  line-height: 1.5;
}
.delete-dialog .delete-footer {
  display: flex;
  justify-content: flex-end;
  gap: 0.75rem;
  padding-top: 1rem;
  border-top: 1px solid #dee2e6;
}
/*# sourceMappingURL=delete-pipeline.component.css.map */
